import { createActions } from 'redux-actions'
import getApi from 'services/api'

const { byCentersStart, byCentersSuccess, byCentersError, byCentersReset } = createActions({
  BY_CENTERS_START: () => {},
  BY_CENTERS_SUCCESS: (values, total) => ({ values, total }),
  BY_CENTERS_ERROR: (error) => ({ error }),
  BY_CENTERS_RESET: () => {},
})

const getByCentersRequest = (query) => {
  return async (dispatch) => {
    const api = await getApi()

    const body = {
      ...query,
      Sort: {
        Name: '',
        IsAscending: true,
      },
      Pager: {
        PageSize: 10,
        PageNumber: query.PageNumber ? query.PageNumber : 1,
      },
    }

    dispatch(byCentersStart())

    return api
      .post('dashboard/summarybycenter', body)
      .then((response) => {
        const dataResponse = response.data.data
        dispatch(byCentersSuccess(dataResponse.distributionCenters, dataResponse.totalCenters))
      })
      .catch((error) => {
        dispatch(byCentersError(error.data ? error.data.message : error.message))
      })
  }
}

export { getByCentersRequest, byCentersStart, byCentersSuccess, byCentersError, byCentersReset }
